export const SAVE_BOARD = 'events/SAVE_BOARD';

/**
 * @param board
 * @return {{type: string, payload: board}
 */
export const saveBoard = (board) => ({
  type: SAVE_BOARD,
  payload: board,
});
